module.exports = __webpack_public_path__ + "img/auction-fill.759f85ca.svg";